const $container = document.querySelector('.js-quest-cover-drag');

if ($container) {
  const $image = $container.querySelector('.js-quest-cover-drag-image');
  const $imageContainer = $container.querySelector('.js-quest-cover-drag-image-container');

  let isDragging = false;
  let startX = 0;
  let startY = 0;
  let currentX = 0;
  let currentY = 0;

  const handleMouseDown = (e) => {
    e.preventDefault();
    isDragging = true;
    startX = e.clientX - currentX;
    startY = e.clientY - currentY;
    $imageContainer.classList.add('is-dragging');
  };

  const handleTouchStart = (e) => {
    e.preventDefault();
    isDragging = true;
    const touch = e.touches[0];
    startX = touch.clientX - currentX;
    startY = touch.clientY - currentY;
    $imageContainer.classList.add('is-dragging');
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;

    e.preventDefault();
    currentX = e.clientX - startX;
    currentY = e.clientY - startY;

    $imageContainer.style.transform = `translate(${currentX}px, ${currentY}px)`;
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;

    e.preventDefault();
    const touch = e.touches[0];
    currentX = touch.clientX - startX;
    currentY = touch.clientY - startY;

    $imageContainer.style.transform = `translate(${currentX}px, ${currentY}px)`;
  };

  const handleMouseUp = () => {
    if (!isDragging) return;

    isDragging = false;
    currentX = 0;
    currentY = 0;
    $imageContainer.classList.remove('is-dragging');
    $imageContainer.style.transform = 'translate(0, 0)';
  };

  $image.addEventListener('mousedown', handleMouseDown);
  $image.addEventListener('touchstart', handleTouchStart);

  document.addEventListener('mousemove', handleMouseMove);
  document.addEventListener('touchmove', handleTouchMove);

  document.addEventListener('mouseup', handleMouseUp);
  document.addEventListener('touchend', handleMouseUp);
}
